// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/17.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_loginContainer__Y6m8l {
  height: 100vh;
  background-color: #ffffff !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  border: none;
}
.login_loginContainer__Y6m8l .login_appBrand__fCXRk {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: 100px;
}
.login_loginContainer__Y6m8l .login_appBrand__fCXRk img {
  max-width: 100%;
  max-height: 100%;
}
.login_loginContainer__Y6m8l .login_appBrand__fCXRk .login_brandLogo__pwqQr {
  width: 100%;
  word-wrap: break-word;
  word-break: break-all;
}
.login_loginContainer__Y6m8l .login_loginFormButton__Bi6u7 {
  width: 100%;
}
.login_loginContainer__Y6m8l .login_copyLink__m3LKW {
  display: block;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/views/login/login.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;AACN;AAEI;EACE,WAAA;EACA,qBAAA;EACA,qBAAA;AAAN;AAIE;EACE,WAAA;AAFJ;AAKE;EACE,cAAA;EACA,WAAA;AAHJ","sourcesContent":[".loginContainer {\n  height: 100vh;\n  background-color: #ffffff !important;\n  background-image: url('../../assets/images/17.jpeg');\n  background-repeat: no-repeat;\n  background-size: cover;\n  border: none;\n\n  .appBrand {\n    flex-grow: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    height: 100px;\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n    }\n\n    .brandLogo {\n      width: 100%;\n      word-wrap: break-word;\n      word-break: break-all;\n    }\n  }\n\n  .loginFormButton {\n    width: 100%;\n  }\n\n  .copyLink {\n    display: block;\n    width: 100%;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `login_loginContainer__Y6m8l`,
	"appBrand": `login_appBrand__fCXRk`,
	"brandLogo": `login_brandLogo__pwqQr`,
	"loginFormButton": `login_loginFormButton__Bi6u7`,
	"copyLink": `login_copyLink__m3LKW`
};
export default ___CSS_LOADER_EXPORT___;
